import { VALIDATION_RULES, ERROR_MESSAGES } from './constants';

export const validateEmail = (value: string): string => {
  if (!value.trim()) {
    return 'Email or username is required';
  }
  
  if (value.includes('@')) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(value)) {
      return 'Please enter a valid email address';
    }
  } else {
    if (value.length < 3) {
      return 'Username must be at least 3 characters';
    }
    if (!/^[a-zA-Z0-9_.-]+$/.test(value)) {
      return 'Username can only contain letters, numbers, dots, hyphens, and underscores';
    }
  }
  
  return '';
};

  export const isValidEmailFormat = (value: string): boolean => {
  return value.includes('@') && /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
};

export const validatePassword = (password:string) => {
  if (!password) return ERROR_MESSAGES.PASSWORD_REQUIRED;
  if (password.length < VALIDATION_RULES.MIN_PASSWORD_LENGTH) return ERROR_MESSAGES.PASSWORD_TOO_SHORT;
  return null;
};

export const validatePhone = (phone:any) => {
  if (!phone) return ERROR_MESSAGES.PHONE_REQUIRED;
  if (!VALIDATION_RULES.PHONE_REGEX.test(phone)) return ERROR_MESSAGES.PHONE_INVALID;
  return null;
};

export const validateOTP = (otp:any) => {
  if (!otp) return ERROR_MESSAGES.OTP_REQUIRED;
  if (otp.length !== VALIDATION_RULES.OTP_LENGTH) return ERROR_MESSAGES.OTP_INVALID;
  return null;
};

export const validateResetEmail = (email:string) => {
  if (!email) return ERROR_MESSAGES.RESET_EMAIL_REQUIRED;
  if (!VALIDATION_RULES.EMAIL_REGEX.test(email)) return ERROR_MESSAGES.RESET_EMAIL_INVALID;
  return null;
};

export const formatPhoneNumber = (phone:any) => {
  return phone.replace(/[^\d+]/g, '');
};

export const maskPhoneNumber = (phone:any) => {
  if (phone.length < 4) return phone;
  const lastFour = phone.slice(-4);
  const masked = '*'.repeat(phone.length - 4);
  return masked + lastFour;
};